/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import { IAddressAddItem, IAddressAddUpdateProps } from '../../common/components/address-add';
import { IAddressShowItem, IAddressShowProps } from '../../common/components/address-show';
import { ICheckoutBillingAddressViewProps } from './checkout-billing-address';

const AddressShow: React.FC<IAddressShowProps> = ({
    AddressDetail,
    items
}) => {

    return (
        <Node {...AddressDetail}>
            {items && items.map((item: IAddressShowItem) => {
                return (
                    <>
                        {item.description}
                    </>
                );
            })}
        </Node>
    );
};

const AddressAddUpdate: React.FC<IAddressAddUpdateProps> = ({
    AddressForm,
    heading,
    items,
    hasError,
    error,
    isShowSaveButton,
    saveButton,
    isShowCancelButton,
    cancelButton,
}) => {

    return (
        <Node {...AddressForm}>
            {heading}
            {items && items.map((item: IAddressAddItem) => {
                const { AddressItem, key, label, alert, input } = item;
                return (<Node {...AddressItem} key={key}>
                    {label}
                    {alert}
                    {input}
                </Node>);
            })}
            {hasError && <Node {...error.AddressError}>
                {error.title}
                {error.message}
            </Node>}
            {isShowSaveButton && saveButton}
            {isShowCancelButton && cancelButton}
        </Node>
    );
};

const CheckoutBillingAddressView: React.FC<ICheckoutBillingAddressViewProps> = props => {
    const { CheckoutBillingAddress, viewState, heading, sameAsShippingCheckbox, showAddress, showAddOrUpdateAddress } = props;

    return (
        <Module {...CheckoutBillingAddress}>
            {heading}
            {viewState.isShowSameAsShippingCheckbox && sameAsShippingCheckbox}
            {viewState.isShowAddress && <AddressShow {...showAddress} />}
            {viewState.isShowAddOrUpdateAddress && <AddressAddUpdate {...showAddOrUpdateAddress} />}
        </Module>
    );
};

export default CheckoutBillingAddressView;
